import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea as UiTextarea } from '@/components/ui/textarea'
import format from '@/lib/format'
import { cn } from '@/lib/utils'
import { ComponentProps, useId } from 'react'

const Textarea = ({
  id,
  label,
  error,
  showCharacterCount,
  ...props
}: Props) => {
  const textareaId = `${id ?? ''}${useId()}`
  const hasError = error ? error !== '' : false

  return (
    <FormItem>
      {label && (
        <FormLabel
          htmlFor={textareaId}
          className={cn('gap-1', error && 'text-destructive')}
        >
          {label}
          {props.required && <span className="text-destructive">*</span>}
        </FormLabel>
      )}
      <FormControl>
        <UiTextarea id={textareaId} {...props} />
      </FormControl>
      <div className="align-center flex justify-between gap-2">
        <FormMessage />

        {showCharacterCount && props.maxLength && (
          <span className="text-muted-foreground ml-auto text-sm tabular-nums">
            {`${format.Number(props.value?.toString().length || 0)} / ${format.Number(props.maxLength)}`}
          </span>
        )}
      </div>
      {hasError && <p>{error}</p>}
    </FormItem>
  )
}

type Props = ComponentProps<'textarea'> & {
  label?: string
  error?: string
  showCharacterCount?: boolean
}

export default Textarea
